import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { trigger } from '@angular/core/src/animation/dsl';
import { ReportService } from '../report.service';
import * as _ from'lodash';
@Component({
  selector: 'app-data-view',
  templateUrl: './data-view.component.html',
  styleUrls: ['./data-view.component.css']
})
export class DataViewComponent implements OnInit {

  names: any = {titulo:'', gestion:'', moneda:'', subtitulo: ''};
  dataSource: any = [];
  popupVisible: boolean = true;
  showJson2: boolean = false;
  url: string;
  loadingVisible: boolean;
  @Input() urlData: any;
  @Input() type: any;
  @Output() loadData = new EventEmitter<any>();
  constructor(private service: ReportService) { }

  ngOnInit() {
    this.loadingVisible = true;
    //console.log('*****',this.type);
    this.service.getDataByUrl(this.urlData).subscribe(resp => {
      //console.log('RESP',resp);
      if(this.type=='map') {
        this.loadingVisible = false;
        this.dataSource = resp;
        let data = Object.keys(this.dataSource).map(item => {return {name: item, data:[]}});
        data.forEach( item => {
          item['extra'] = this.dataSource[item.name];
          this.dataSource[item.name].data.forEach((_item, index) => {
            _item.codigo_subgrupo = Number(_item.codigo_subgrupo);
            _item.codigo_grupo = Number(_item.codigo_grupo);
            _item['id'] = index + 1;
          });
            let keys = _.remove(this.dataSource[item.name].data, (n) => {
              return n.codigo_subgrupo == -1;
            });
            let f = _.groupBy(this.dataSource[item.name].data, 'codigo_grupo');
            //console.log(f);
            keys.forEach(element => {
              element['parent'] = 0;
              f[element.codigo_grupo].forEach(itm => {
                itm['parent'] = element.id;
                keys.push(itm);
              });
            });
            item.data = keys;
        });
        this.dataSource = data;
        //console.log(this.dataSource);
        
      } 
      if(this.type=='chart') {
        this.service.updateNameBreadcrumb(`${resp.titulo} ${resp.subtitulo?resp.subtitulo:''}`,1);
        this.loadingVisible = false;
        this.names = resp;
        this.dataSource = resp.data;
        this.dataSource.forEach((item, index) => {
          item.codigo_subgrupo = Number(item.codigo_subgrupo);
          item.codigo_grupo = Number(item.codigo_grupo);
          item['id'] = index + 1;
        });
        let keys = _.remove(this.dataSource, (n) => {
          return n.codigo_subgrupo == -1;
        });
        let f = _.groupBy(this.dataSource, 'codigo_grupo');
        keys.forEach(element => {
          element['parent'] = 0;
          f[element.codigo_grupo].forEach(itm => {
            itm['parent'] = element.id;
            keys.push(itm);
          });
        });
        this.dataSource = keys;
        }
    }, err => {
      this.loadingVisible = false;
    });
  }

  open2(data) {
    this.loadData.emit(data);
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/report/data-view/data-view.component.ts